import { toViewCart } from "~/sdk/ga4/events/view_cart"
import { toAddToCart } from "~/sdk/ga4/events/add_to_cart"
import { toRemoveFromCart } from "~/sdk/ga4/events/remove_from_cart"
import { toBeginCheckout } from "~/sdk/ga4/events/begin_checkout"
import { toViewPromotion } from "~/sdk/ga4/events/view_promotion"
import { toSelectPromotion } from "~/sdk/ga4/events/select_promotion"
import { toViewItem } from "~/sdk/ga4/events/view_item"
import { toViewItemList } from "~/sdk/ga4/events/view_item_list"
import { toSelectItem } from "~/sdk/ga4/events/select_item"
import { toAddToWishlist } from "~/sdk/ga4/events/add_to_wishlist"
import type { AnalyticsEventTypes, ToAnalyticsProps } from "~/sdk/ga4/types/index"

type HandlerReturnTypes = {
    view_cart: ReturnType<typeof toViewCart>
    add_to_cart: ReturnType<typeof toAddToCart>
    remove_from_cart: ReturnType<typeof toRemoveFromCart>
    begin_checkout: ReturnType<typeof toBeginCheckout>
    view_promotion: ReturnType<typeof toViewPromotion>
    select_promotion: ReturnType<typeof toSelectPromotion>
    view_item: ReturnType<typeof toViewItem>
    view_item_list: ReturnType<typeof toViewItemList>
    select_item: ReturnType<typeof toSelectItem>
    add_to_wishlist: ReturnType<typeof toAddToWishlist>
}

const handlers: {
    [T in keyof AnalyticsEventTypes]: (
        data: AnalyticsEventTypes[T],
    ) => HandlerReturnTypes[T]
} = {
    view_cart: toViewCart,
    add_to_cart: toAddToCart,
    remove_from_cart: toRemoveFromCart,
    begin_checkout: toBeginCheckout,
    view_promotion: toViewPromotion,
    select_promotion: toSelectPromotion,
    view_item: toViewItem,
    view_item_list: toViewItemList,
    select_item: toSelectItem,
    add_to_wishlist: toAddToWishlist,
}

export const toAnalytics = <T extends keyof AnalyticsEventTypes>({
    type,
    data,
}: ToAnalyticsProps<T>) => {
    if (!type) {
        throw new Error('Type is undefined')
    }

    const handler = handlers[type]

    if (!handler) {
        throw new Error(`Unsupported type: ${type}`)
    }

    return handler(data)
}
